export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};

  const authObj = {};

  if (currentUser !== undefined) {
    Object.keys(authObj).forEach((key) => {
      // @ts-expect-error
      authObj[key] = true;
    });
    // const rights = currentUser?.right_keys ?? [];
    // if (rights.includes("*")) {
    //   Object.keys(authObj).forEach((key) => {
    //     // @ts-expect-error
    //     authObj[key] = true;
    //   });
    // } else {
    //   Object.keys(authObj).forEach((key) => {
    //     // @ts-expect-error
    //     authObj[key] = rights.includes(key) || false;
    //   });
    // }
  }

  return {
    ...authObj,
  };
}
